import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import Tooltip from "../../../componentLibrary/Tooltip";

export default function HelpComponents() {
  return (
    <>
      <h2 className="underline">Help & Guidance</h2>

      <div className="space-y-6">
        {/* Tooltips */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">Tooltips</h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Helpful information overlays that appear on hover or focus. Used
              throughout the application to provide additional context,
              explanations, and guidance. Supports multiple positions (top,
              right, left, bottom) and custom content.
            </p>
          </div>
          <div className="flex flex-wrap gap-4 justify-center">
            <Tooltip
              icon={
                <InformationCircleIcon className="w-5 h-5 text-gray-600 hover:text-blue-500 transition-colors" />
              }
              text="This is a top tooltip"
            />
            <Tooltip
              icon={
                <InformationCircleIcon className="w-5 h-5 text-gray-600 hover:text-blue-500 transition-colors" />
              }
              text="This is a right tooltip"
              position="right"
            />
            <Tooltip
              icon={
                <InformationCircleIcon className="w-5 h-5 text-gray-600 hover:text-blue-500 transition-colors" />
              }
              text="This is a left tooltip"
              position="left"
            />
            <Tooltip
              icon={
                <InformationCircleIcon className="w-5 h-5 text-gray-600 hover:text-blue-500 transition-colors" />
              }
              text="This is a bottom tooltip"
              position="bottom"
            />
          </div>
        </div>
      </div>
    </>
  );
}
